var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{staticClass:"search-location-field w-100",staticStyle:{"min-width":"180px"},attrs:{"clearable":"","flat":"","solo":"","placeholder":"Asukoht","hide-details":"auto","items":_vm.options},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }